<!-- src/plugins/offer-goldsoft/OfferGoldSoftCard.vue -->
<template>
  <section class="offer-goldsoft-section">
    <div class="offer-goldsoft__panel">
      <div class="offer-hero__grid">

        <!-- 左側 -->
        <div class="offer-hero__left">
          <h2 class="offer-hero__title">Web3 項目速成課程【全套】</h2>
          <p class="offer-hero__sub">
            這是能夠改變你人生的課程，<strong>立即行動起來</strong>！
          </p>

          <div class="offer-hero__price">
            <div class="price__row">
              <span class="sym">$</span>
              <span class="num">488</span>
              <span class="unit">USD / 全套</span>
            </div>
            <div class="price__note">倒數結束後恢復 <del>$688</del></div>
          </div>

          <div class="offer-hero__actions">
            <a
              class="btn btn--gold"
              href="https://ifdian.net/item/1a76a3ae484011edb69d52540025c377"
              target="_blank"
              rel="noopener"
            >微信 / 支付寶 付款</a>
            <a
              class="btn btn--light"
              href="https://www.patreon.com/collection/608906"
              target="_blank"
              rel="noopener"
            >信用卡 / PayPal 付款</a>
          </div>

          <p class="offer-hero__tip">
            ⚠️ 付款將跳轉至「愛發電」或「Patreon」自動發碼平台，自助完成，無須聯繫院長。
          </p>
        </div>

        <!-- 右側倒數（到期自動消失） -->
        <div class="offer-hero__right" v-if="!isExpired">
          <div class="pill-cd">
            <div class="pill-item">
              <div class="pill-num">{{ dd }}</div>
              <div class="pill-lab">Days</div>
            </div>
            <span class="pill-sep">:</span>
            <div class="pill-item">
              <div class="pill-num">{{ hh }}</div>
              <div class="pill-lab">Hours</div>
            </div>
            <span class="pill-sep">:</span>
            <div class="pill-item">
              <div class="pill-num">{{ mm }}</div>
              <div class="pill-lab">Minutes</div>
            </div>
            <span class="pill-sep">:</span>
            <div class="pill-item">
              <div class="pill-num">{{ ss }}</div>
              <div class="pill-lab">Seconds</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

/**
 * 倒計時規則：
 * 1) 第一次開啟：記錄 openedAt = now，deadline = openedAt + 1 天 18 小時
 * 2) 之後每次開啟：沿用同一個 openedAt，持續倒計時
 * 3) 若現在時間 >= deadline：視為到期，倒計時區塊隱藏
 * 4) 若距離 openedAt 已超過 7 天：重置 openedAt = now，重新給一個倒計時
 */
const STORAGE_KEY = 'offerGoldsoft.openedAt.v2' // 改版本即可重置所有人
const ONE_HOUR = 60 * 60 * 1000
const ONE_DAY = 24 * ONE_HOUR
const ONE_DAY_18H = ONE_DAY + 18 * ONE_HOUR // ✅ 預設 1 天 18 小時
const SEVEN_DAYS = 7 * ONE_DAY

const dd = ref(0), hh = ref(0), mm = ref(0), ss = ref(0)
const isExpired = ref(false)
let deadline = 0
let timer = null

function loadOrInitOpenedAt() {
  const now = Date.now()
  const raw = localStorage.getItem(STORAGE_KEY)
  let openedAt = raw ? Number(raw) : NaN

  if (!raw || !Number.isFinite(openedAt)) {
    // 第一次來訪
    openedAt = now
    localStorage.setItem(STORAGE_KEY, String(openedAt))
  } else {
    // 若超過 7 天，允許重置
    if (now - openedAt >= SEVEN_DAYS) {
      openedAt = now
      localStorage.setItem(STORAGE_KEY, String(openedAt))
    }
  }
  return openedAt
}

function setDeadlineFrom(openedAt) {
  deadline = openedAt + ONE_DAY_18H // ✅ 42 小時
  isExpired.value = Date.now() >= deadline
}

function tick() {
  const diff = deadline - Date.now()
  if (diff <= 0) {
    isExpired.value = true
    clearInterval(timer)
    dd.value = hh.value = mm.value = ss.value = 0
    return
  }
  dd.value = Math.floor(diff / 86400000)
  hh.value = Math.floor((diff % 86400000) / 3600000)
  mm.value = Math.floor((diff % 3600000) / 60000)
  ss.value = Math.floor((diff % 60000) / 1000)
}

onMounted(() => {
  const openedAt = loadOrInitOpenedAt()
  setDeadlineFrom(openedAt)

  if (!isExpired.value) {
    tick()
    timer = setInterval(tick, 1000)
  }

  const onVis = () => {
    if (document.visibilityState === 'visible') tick()
  }
  document.addEventListener('visibilitychange', onVis)
  window.__offerGoldSoft_onVis = onVis
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
  if (window.__offerGoldSoft_onVis) {
    document.removeEventListener('visibilitychange', window.__offerGoldSoft_onVis)
    delete window.__offerGoldSoft_onVis
  }
})
</script>


<style scoped>
.offer-goldsoft-section {
  background: linear-gradient(180deg, #f7ce76 0%, #f5c86b 100%);
  color: #111;
  padding: 80px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.offer-goldsoft__panel {
  max-width: 1100px;
  margin: 0 auto;
  border-radius: 22px;
  padding: 40px 36px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px) saturate(150%);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* ===== 內容區 ===== */
.offer-hero__grid {
  display: grid;
  grid-template-columns: 1.4fr 0.9fr;
  gap: 36px;
  align-items: start;
}

/* 標題 / 文案 */
.offer-hero__title {
  margin: 0 0 12px;
  font-weight: 900;
  font-size: clamp(26px, 3.2vw, 38px);
  color: #0e1013;
}

.offer-hero__sub {
  font-size: clamp(15px, 1.6vw, 18px);
  color: #1a1a1a;
  line-height: 1.7;
  margin-bottom: 20px;
}

/* 價格 */
.offer-hero__price {
  margin: 16px 0 24px;
}

.price__row {
  display: flex;
  align-items: flex-end;
  gap: 6px;
}

.price__row .sym {
  font-size: 22px;
  color: #111;
}

.price__row .num {
  font-weight: 900;
  font-size: clamp(38px, 5vw, 54px);
  color: #111;
}

.price__row .unit {
  font-size: 14px;
  color: rgba(17, 17, 17, 0.7);
}

.price__note {
  color: rgba(17, 17, 17, 0.6);
  font-size: 15px;
}

/* 按鈕群 */
.offer-hero__actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 18px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: 12px;
  text-decoration: none;
  transition: 0.2s;
  font-weight: 700;
}

.btn--gold {
  background: linear-gradient(135deg, #fff3b0, #f2c84d);
  color: #111;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.btn--gold:hover {
  transform: translateY(-2px);
}

.btn--light {
  background: #fff;
  color: #111;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.btn--light:hover {
  background: #fffbe6;
  transform: translateY(-2px);
}

/* 提示文字 */
.offer-hero__tip {
  margin-top: 14px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
}

/* 倒數膠囊 */
.offer-hero__right {
  display: grid;
  place-items: start end;
}

.pill-cd {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: #111;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.pill-item {
  display: grid;
  place-items: center;
  min-width: 90px;
}

.pill-num {
  font-weight: 900;
  font-size: clamp(22px, 3.4vw, 36px);
}

.pill-lab {
  font-size: 11px;
  opacity: 0.8;
  text-transform: uppercase;
}

.pill-sep {
  font-size: clamp(16px, 2.4vw, 22px);
  font-weight: 900;
  opacity: 0.85;
  transform: translateY(-2px);
}
@media (max-width: 1024px) {
  /* 內部改為上下排列，避免壓縮 */
  .offer-hero__grid {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 20px;
  }

  /* 倒數膠囊置中、縮小間距 */
  .pill-cd {
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 12px;
    gap: 10px;
    transform: scale(0.9);
  }

}
</style>
